import axios from 'axios';
import { URI_ORGANISATIONS } from '../helpers/constans';
import {
  IOrganisationAccess,
  IOrganisationAccessUpdatePayload,
  IOrganisationEventsResponse,
  IOrganisationGetResponseOk,
  IOrganisationPayload,
  IOrganisationPutResponseOk,
  IOrganisationTeamsResponse,
  TOrganisationGetAllPayload,
  IInstagramConversationListResponse,
  IInstagramConversationDetailResponse,
  TInstagramConversationStatus,
} from '../types/@organisation';

export const fetchOrganisationGet = (
  page: TOrganisationGetAllPayload
): Promise<IOrganisationGetResponseOk> => {
  return axios.get(`${URI_ORGANISATIONS}?page=${page}`);
};

export const fetchOrganisationPut = (payload: IOrganisationPayload): Promise<IOrganisationPutResponseOk> => {
  return axios.post(URI_ORGANISATIONS, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const fetchOrganisationAccessGet = (id: string): Promise<IOrganisationAccess> => {
  return axios.get(`${URI_ORGANISATIONS}/${id}/access`);
};

export const fetchOrganisationTeamsGet = (id: string): Promise<IOrganisationTeamsResponse> => {
  return axios.get(`${URI_ORGANISATIONS}/${id}/teams`);
};

export const fetchOrganisationEventsGet = (id: string): Promise<IOrganisationEventsResponse> => {
  return axios.get(`${URI_ORGANISATIONS}/${id}/events`);
};

export const fetchOrganisationAccessPut = (
  id: string,
  payload: IOrganisationAccessUpdatePayload
): Promise<IOrganisationAccess> => {
  return axios.put(`${URI_ORGANISATIONS}/${id}/access`, payload);
};

export const fetchOrganisationRemoveMember = (id: string, userId: string): Promise<{ successful: boolean }> => {
  return axios.delete(`${URI_ORGANISATIONS}/${id}/membership/${userId}`);
};

export const fetchOrganisationLeave = (id: string): Promise<{ successful: boolean }> => {
  return axios.delete(`${URI_ORGANISATIONS}/${id}/membership/me`);
};

export const fetchOrganisationSocialConnections = (id: string) => {
  return axios.get(`${URI_ORGANISATIONS}/${id}/social-connections`);
};

export const fetchOrganisationSocialApprovalRequest = (id: string, platform: string) => {
  return axios.post(`${URI_ORGANISATIONS}/${id}/social/${encodeURIComponent(platform)}/authorise`, {});
};

export const fetchOrganisationInstagramApprovalRequest = (id: string) => {
  return fetchOrganisationSocialApprovalRequest(id, 'instagram');
};

export const fetchOrganisationSocialDisconnect = (id: string, platform: string) => {
  return axios.delete(`${URI_ORGANISATIONS}/${id}/social/${encodeURIComponent(platform)}`);
};

export const fetchOrganisationInstagramApprovalComplete = (id: string, payload: { code: string; redirectUri?: string }) => {
  return axios.post(`${URI_ORGANISATIONS}/${id}/social/instagram/complete`, payload);
};


export const fetchInstagramTestPublish = (
  id: string,
  payload: { mediaUrl?: string; caption?: string; mentions?: string[]; fetchInsights?: boolean },
) => {
  return axios.post(`${URI_ORGANISATIONS}/${id}/social/instagram/test-publish`, payload);
};



export const fetchInstagramConversations = (
  id: string,
  status?: TInstagramConversationStatus,
): Promise<IInstagramConversationListResponse> => {
  const query = status ? `?status=${encodeURIComponent(status)}` : '';
  return axios.get(`${URI_ORGANISATIONS}/${id}/messages/conversations${query}`);
};

export const fetchInstagramConversation = (
  id: string,
  conversationId: string,
): Promise<IInstagramConversationDetailResponse> => {
  return axios.get(`${URI_ORGANISATIONS}/${id}/messages/conversations/${conversationId}`);
};

export const sendInstagramConversationReply = (
  id: string,
  conversationId: string,
  text: string,
) => axios.post(`${URI_ORGANISATIONS}/${id}/messages/conversations/${conversationId}/replies`, { text });

export const updateInstagramConversation = (
  id: string,
  conversationId: string,
  payload: { status?: TInstagramConversationStatus; assignedTo?: string | null },
) => axios.put(`${URI_ORGANISATIONS}/${id}/messages/conversations/${conversationId}`, payload);
